import React from "react";
import BigCardsComponent from "../MaldiveEventsCards/ChildComponents/BigCardsComponent/BigCardsComponent.view";
import { BigCardsComponentMockData } from "../MaldiveEventsCards/ChildComponents/BigCardsComponent/BigCardsComponent.mock.data";

import "./MaldiveEventsCards.style.scss";

const MaldiveEventsCards = () => {
  return (
    <div
      id="maldive-events-cards"
      className="maldive-events-cards d-flex flex-column"
    >
      <div className="events-cards-bg"></div>
      {BigCardsComponentMockData.map((card, index) => (
        <div key={index}>
          <BigCardsComponent card={card} />
        </div>
      ))}
    </div>
  );
};

export default MaldiveEventsCards;
